

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./styles/blogArticle.css";
import "./styles/redesign.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { RecoilRoot } from "recoil";
import { ThemeProvider } from "@mui/material/styles";
import { kstheme } from "./theme/theme";
import { CssBaseline } from "@mui/material";
import RecoilNexus from "recoil-nexus";
import { initMarketingTags, initBlogCtaEvents } from './marketingTags';

initMarketingTags();
initBlogCtaEvents();

// Capture the prerendered article before ReactDOM.render clears the root.
// BlogDetail uses it for the first client render so downstream sections keep
// their exact vertical position while the source fragment is refreshed.
const prerenderedArticle = document.querySelector(
  ".blog-static-prerender .blog-article-content"
);
window.__SAFEVAULT_PRERENDERED_ARTICLE_HTML__ = prerenderedArticle
  ? prerenderedArticle.innerHTML
  : "";

const handleWheel = (event) => {
  const tagName = event.target.tagName.toLowerCase();
  if (tagName === "input" && event.target.type === "number") {
    event.preventDefault();
  }
};

ReactDOM.render(
  <React.StrictMode>

    <RecoilRoot>
      <RecoilNexus />

      <ThemeProvider theme={kstheme}>
        <CssBaseline>
          <App />
        </CssBaseline>
      </ThemeProvider>

    </RecoilRoot>

  </React.StrictMode>,
  document.getElementById("root")
);

document.addEventListener("wheel", handleWheel, { passive: false });
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
